/*
 *  Interface représentant un service telle qu'utilisée dans l'application React et l'application API
 *  Contient également l'interface pour les types de taux de taxe (ex: 20%, 10%, 5.5%, etc.).
 *  Ainsi que l'interface pour les types d'unité (ex: demi-forfait, forfait, unité).
 */

export interface TaxRateData {
	id?: number;
	code: string;
	label: string;
	rate: number;
	country: string;
	isActive: boolean;
}

export interface UnitTypeData {
	code: string;
	label: string;
	isActive?: boolean;
}

export interface ServiceData {
	// Obligatoires
	id: number;
	label: string;
	// Champs simples
	description?: string;
	defaultPrice?: number;
	forSale?: boolean;
	forPurchase?: boolean;
	// Relations
	defaultTaxRate?: TaxRateData | null;
	unitType?: UnitTypeData;
}

/*
export const TaxRateOptions = [
	{ key: 'TVA_FR_20', label: 'TVA France 20%' },
	{ key: 'TVA_FR_10', label: 'TVA France 10%' },
	{ key: 'TVA_FR_5.5', label: 'TVA France 5.5%' },
];
*/

export const UnitTypeOptions = [
	{ key: 'UNIT', label: 'Unité' },
	{ key: 'DEMI_FORFAIT', label: 'Demi-Forfait' },
	{ key: 'FORFAIT', label: 'Forfait' },
];
